import React from 'react';
import { Box } from '@mui/material';
import DropdownSelect from '../../Components/DropdownSelect';
import { LOCALIZATION_OPTIONS } from '../Constants';
import { useSelector, useDispatch } from 'react-redux';
import TranslateIcon from '@mui/icons-material/Translate';
import { setLocalizeLanguage } from '../../redux/localization/actions';
import { getCountryFlag } from '../../helpers/country';
import { useTheme } from '@mui/material';

const LocalizationDropdown = () => {
  const dispatch = useDispatch();
  const activeLanguage = useSelector((state) => state.localization?.selectedLanguage);
  const theme = useTheme();

  return (
    <Box data-use-translation={false}>
      <DropdownSelect
        menuSlotProps={{
          paper: {
            id: 'localization-options',
          },
        }}
        onSelect={(value) => {
          if (value !== activeLanguage?.value) {
            dispatch(setLocalizeLanguage(LOCALIZATION_OPTIONS.find((option) => option.value === value)));
            window.location.reload();
          }
        }}
        value={activeLanguage?.value || LOCALIZATION_OPTIONS[0].value}
        options={LOCALIZATION_OPTIONS}
        customLabel={
          <Box display="flex" alignItems="center" gap={2}>
            <TranslateIcon />
            {activeLanguage?.flag ? (
              <img height="16px" src={getCountryFlag(activeLanguage?.flag)} alt={activeLanguage?.value} />
            ) : null}
          </Box>
        }
        showArrow={false}
        buttonProps={{
          sx: {
            border: `1px solid ${theme.palette.background.main}`,
            padding: '4px 8px',
            '&:hover': {
              border: `1px solid ${theme.palette.background.main}`,
            },
          },
          variant: 'outlined',
        }}
        preventTranslation={true}
      />
    </Box>
  );
};

export default LocalizationDropdown;
